"use strict";

exports.__esModule = true;
exports.TimelineValueFields = TimelineValueFields;
var _core = require("@blueprintjs/core");
var _react = _interopRequireDefault(require("react"));
var _Translator = require("../../Core/Translator");
var _timelineDefinitions = require("../../Timeline/timelineDefinitions");
var _TimelineSelector = require("../../Timeline/TimelineSelector");
var _excluded = ["onChange", "value"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var TimelineSelectorAdaptor = function TimelineSelectorAdaptor(_ref) {
  var onChange = _ref.onChange,
    value = _ref.value,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var selectedItem = value && (0, _timelineDefinitions.getTimelineDefinition)(value);
  return /*#__PURE__*/_react["default"].createElement(_TimelineSelector.TimelineSelector, _extends({
    onSelect: function onSelect(selected) {
      return onChange(selected.length > 0 ? selected[0].name : undefined);
    },
    items: _timelineDefinitions.timelineDefinitions.filter(function (definition) {
      return definition.name !== _timelineDefinitions.TIME_SERIES_CONDITION;
    }),
    selected: selectedItem ? [selectedItem] : []
  }, extra));
};

/**
 * Fields for TimelineValueElement.
 */
function TimelineValueFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref2) {
    var translate = _ref2.translate;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("TimelineValueFields.timelineName.label", "Timeline")
    }, /*#__PURE__*/_react["default"].createElement(TimelineSelectorAdaptor, {
      value: element.props.timelineName,
      onChange: function onChange(value) {
        return elementEditor.setProp(path, "timelineName", value);
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
      checked: element.props.hideLabel || false,
      label: translate("TimelineValueFields.hideLabel.label", "Hide Label"),
      onChange: function onChange(e) {
        return elementEditor.setProp(path, "hideLabel", e.target.checked);
      }
    }));
  });
}